import { useGetProvincesQuery } from '../domainsApi';

export function useGetProvincesList(countryCode: string) {
  const {
    data: provinces,
    isLoading,
    isError,
  } = useGetProvincesQuery(countryCode, {
    skip: !countryCode,
  });

  return {
    provinces: provinces ?? null,
    isLoading,
    isError,
  };
}
